import { z } from 'zod';
import { BaseEventSchema } from './Base';

export const ClickEventSchema = BaseEventSchema.extend({
  button_text: z.string(),
  payment_methods_registered: z.number().optional(),
});

export const SearchEventSchema = BaseEventSchema.extend({
  search_string: z.string(),
  search_results: z.number(),
  search_load_more_iteration: z.number().optional(),
  search_perfect_results: z.number(),
  search_not_perfect_results: z.number(),
});

export const SelectInstallmentsEventSchema = BaseEventSchema.extend({
  quantity: z.number(),
});

export enum InteractionEventTypes {
  RedirectNewPaymentMethod = 'interaction.redirect_new_payment_method',
  Search = 'interaction.search',
  SearchLoadMore = 'interaction.search.load_more',
  SelectInstallments = 'interaction.select_installments',
}

export const InteractionEventTrackingSchemas = {
  [InteractionEventTypes.RedirectNewPaymentMethod]: ClickEventSchema,
  [InteractionEventTypes.Search]: SearchEventSchema,
  [InteractionEventTypes.SearchLoadMore]: SearchEventSchema,
  [InteractionEventTypes.SelectInstallments]: SelectInstallmentsEventSchema,
} as const;
